/* import { Button } from 'reactstrap'; */

// interface
import { BasicDetailsTypes } from '../../../data/settings';

interface PersonalInfoProps {
    basicDetails: BasicDetailsTypes;
}
const PersonalInfo = ({ basicDetails }: PersonalInfoProps) => {
    const fullName = basicDetails
        ? `${basicDetails?.person.firstName} ${basicDetails?.person.lastName}`
        : '-';
    return (
        <div className="accordion-body">
            {/* <div className="float-end">
                <Button
                    color="none"
                    type="button"
                    className="btn btn-soft-primary btn-sm"
                >
                    <i className="bx bxs-pencil align-middle"></i>
                </Button>
            </div> */}

            <div>
                <p className="text-muted mb-1">Name</p>
                <h5 className="font-size-14">{fullName}</h5>
            </div>

            <div className="mt-4">
                <p className="text-muted mb-1">Email</p>
                <h5 className="font-size-14">
                    {basicDetails && basicDetails.person.email
                        ? basicDetails.person.email
                        : '-'}
                </h5>
            </div>

            <div className="mt-4">
                <p className="text-muted mb-1">Phone Number</p>
                <h5 className="font-size-14 mb-0">
                    {basicDetails && basicDetails.person.phoneNumber}
                </h5>
            </div>
        </div>
    );
};

export default PersonalInfo;
